import React from "react";
import InvoiceInterface from "../interface/invoiceInterface";
import MarketRepository from "../../Main/repository/MarketRepository";
import MarketCartLocalstorage from "../../Main/interface/MarketCartLocalstorage";
import AppSettingController from "../../Main/controller/AppSettingController";
import {find, toNumber} from "lodash";
import ProductImage from "./ProductImage";
import ProductController from "../../Products/controller/ProductController";
import {Table} from "react-bootstrap";
import {ReactComponent as MinusIcon} from '../assets/image/minus.svg';
import {ReactComponent as TrashIcon} from '../assets/image/trash.svg';
import {ReactComponent as PlusIcon} from '../assets/image/plus.svg';
import MarketSetting from "../../Main/interface/MarketSettingLocalStorage";
import {ReactComponent as CashIcon} from "./../assets/image/cash.svg";
import AppCartController from "../../Main/controller/AppCartController";
import {useTranslation} from "react-i18next";

export default function InvoiceTable({state, setState}: {
    state: InvoiceInterface,
    setState: React.Dispatch<React.SetStateAction<InvoiceInterface>>
}) {
    const {t, i18n} = useTranslation();
    const lang = i18n.language === 'ar-IQ' ? 'ar-IQ' : 'fa-IR';
    const card = MarketRepository.getCartMarket() as MarketCartLocalstorage;
    const setting = AppSettingController.getSetting() as MarketSetting;
    const hasTax = card.items?.some(item => toNumber(item.tax) > 0) ?? false;

    return (
        <Table>
            <thead>
            <tr>
                <th>{t("table.productName")}</th>
                <th>{t("table.count")}</th>
                {!AppSettingController.isHiddenPrice() ? <th>{t("table.price")}</th> : null}
                {hasTax ? <th>{t("table.tax")}</th> : null}
                <th>{t("table.operation")}</th>
            </tr>
            </thead>
            <tbody>
            {card.items?.map(item => {
                const isCan = find(state.notAvailableProduct, {_id: item._id});
                return (
                    <tr key={item._id}>
                        <td className={'name-product'}>
                            <div>
                                <ProductImage image={item.image}/>
                                <span className={isCan ? 'error' : ''}>{item.title}</span>
                            </div>
                        </td>
                        <td className={'flex-center'}>
                            <div>{item.quantity}</div>
                        </td>
                        {!AppSettingController.isHiddenPrice() ? <td className={'flex-center'}>
                            <div>{item.price.toLocaleString(lang)}</div>
                        </td> : null}
                        {hasTax ?<td className={'flex-center'}>
                             <div>{item.tax ? `${item.tax}%` : 0}</div>
                        </td> : null}
                        <td className={'management'}>
                            <div>
                                <PlusIcon
                                    onClick={() => ProductController.addToInvoiceCart(item, state, setState)}/>
                                {~~item.quantity > 1 ? (
                                    <MinusIcon
                                        onClick={() => ProductController.removeToInvoiceCart(item, state, setState)}/>
                                ) : (
                                    <TrashIcon className={'delete-item'}
                                               onClick={() => ProductController.removeToInvoiceCart(item, state, setState)}/>
                                )}
                            </div>
                        </td>
                    </tr>
                )
            })}
            {setting.extraCosts?.length ? setting.extraCosts?.map(item => {
                const priceSum = AppCartController.priceSum();
                if (item.state === 'deactivate') return null
                return (
                    <tr key={item.id}>
                        <td className={'name-product'} colSpan={2}>
                            <div>
                                <div className="no-image">
                                    <CashIcon/>
                                </div>
                                <span>{item.extraCostsName}</span>
                            </div>
                        </td>
                        {!AppSettingController.isHiddenPrice() ? <td className={'flex-center'}>
                            <div>{item.type === 'price' ? toNumber(item.extraCostsPrice).toLocaleString(lang) : ((priceSum * toNumber(item.extraCostsPercentage)) / 100).toLocaleString(lang)}</div>
                        </td> : null}
                    </tr>
                )
            }) : null}
            </tbody>
        </Table>
    );
}